/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.1.4
* 
*******************************************************************************/
import _includesInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/includes";const DEFAULT_HTTP_PROTOCOL="https:",VALID_HTTP_PROTOCOLS=["https:","http:"],relativeProtocolToAbsolute=t=>{var o,e;let l=null===(o=window)||void 0===o||null===(e=o.location)||void 0===e?void 0:e.protocol;return l&&_includesInstanceProperty(VALID_HTTP_PROTOCOLS).call(VALID_HTTP_PROTOCOLS,l)||(l="https:"),`${l}${t}`};export default relativeProtocolToAbsolute;